<template>
    <div v-show="isShow" :style="domStyle">
        <div ref="pie" style="height:100%;width:100%"></div>
        <div v-if="isEnable" :style="enableStyle"></div>
    </div>
</template>
<script>
export default {
    name : "fvPie",
    props : ["primitives","fvSystemApi","parentObject"],
    created (){
        //窗口边框宽度。计算图元和组件位置时需要
        this.defaultTailoring = this.parentObject.defaultTailoring;
        //窗口大小
        this.windowSize = this.parentObject.windowSize;
        //创建组件
        this.create();
        //父组件（可能是窗口也可能是组）vuex数据模型路径数组
        this.modelsPath = this.parentObject.modelsPath.slice(0);
        //创建本省的vuex数据模型
        this.modelsPath.push(this.registerName);
        this.$store.registerModule(this.modelsPath,{
            state : {
                $ : this
            }
        });
    },
    data (){
        return {
            //是否可用
            isEnable : false,
            //是否显示
            isShow : true,
            //组件大小位置,在created(创建完毕，挂载前)函数中初始化
            domStyle : {},
            virtualData : []        //存储实时数据
        }
    },
    mounted(){
        // 基于准备好的dom，初始化echarts实例
        this.myChart = this.$echarts.init(this.$refs.pie);
        this.drawPie()
    },
    computed: {
        realData(){
            var disposeData = [];
            // 将实时数据处理为饼图展示数据
            this.virtualData.forEach((el) => {
                disposeData.push({
                    name : el.name,
                    value: el.value,   
                    itemStyle : {
                        normal: {
                            color : el.color
                        }
                    }
                })
            })
            return disposeData
        }  
    },
    methods : {
        create(){
            this.mixin(this.primitives);
           //组件大小位置初始化
            this.domStyle = {
                position : "absolute",
                left : this.x + "px",
                top : this.y + "px",
                width : this.width + "px",
                height : this.height + "px",
                textAlign : 'center',
                lineHeight : this.height + "px",
                // border: '1px solid red'
            }
            this.enableStyle = {
                position: "absolute",
                width: "100%",
                height: "100%",
                top: "0px",
                backgroundColor: "#ccbfbf",
                opacity: "0.5"
            }

            this.option = {
                title: { 
                    text: this.title, //标题
                    textStyle:{
                        color:this.titleColor, //颜色
                        fontSize :this.titleSize, //大小
                    },
                    show:true, //显隐
                    left:this.titleLocation, //位置
                },
                backgroundColor:this.backgroundColor,
                color:this.color,
                tooltip: {
                    trigger: 'item',
                    formatter: (a)=>{
                        return a.name + "：" + a.value.toFixed(2)
                    },
    		        textStyle:{    //图例文字的样式
                        color:'#fff',  //文字颜色
                        fontSize:10,    //文字大小
                    }
    		    },
                legend: {
                    bottom:0,
                    itemWidth:10,  //图例标记的图形宽度
                    itemHeight:10, //图例标记的图形高度
    		        textStyle:{    //图例文字的样式
                        color:'#A6A8B6',  //文字颜色
                        fontSize:10    //文字大小
                    },
                    itemGap :1,
                    data:[],
                },
                series : [
                    {
                        type:'pie',
                        data:[],
                        radius : '40%',
                        center: this.getPieLocation(),
                        itemStyle:{    
                            normal: {
                                shadowColor: 'rgba(0, 0, 0, 0.5)',
                                shadowBlur: 10,
                                shadowOffsetX:10,
                                label:{  
                                    show:true,  
                                    formatter:'{d}%'  
                                },
                                color:"#aaa"
                            },
                        },  
                        label: {
                            normal: {
                                show: true,//是否显示标签
                                // 标签的位置。'outside'饼图扇区外侧，通过视觉引导线连到相应的扇区。'inside','inner' 同 'inside',饼图扇区内部。'center'在饼图中心位置。
                                position: 'right',
                                //显示的标签的内容
                                //a（系列名称），b（数据项名称），c（数值）, d（百分比）
                                formatter: "{b}({d}%)",
                            },
                            emphasis: {
                                //鼠标放在圆环上显示的标签样式
                                show: true,
                                textStyle: {
                                    fontSize: '12',
                                    fontWeight: 'bold'
                                }
                            }
                        },
                        labelLine: {
                            normal: {
                                show: true,//是否显示引导线
                                length:5,  //百分比引导线
                                length2:10    //视觉引导项第二段的长度。
                            }
                        }
                    }
                ]
            }
        },
        //混入属性
        mixin(src) {
            for (var key in src) {
                this[key] = src[key]
            }
        },
        /*
            参数：scaleObj 重绘信息
            作用：组件需要重绘时触发
        */
        reDraw(scaleObj){
            this.setPieTitle();
            if(this.fontSize){
                this.domStyle.fontSize = parseInt(parseInt(this.fontSize.substr(0, this.fontSize.length - 2)) * (scaleObj.sy + scaleObj.zoom) + scaleObj.oy) + "px"; 
            }
            this.domStyle.left = parseInt((this.x * (scaleObj.sx + scaleObj.zoom)) + scaleObj.ox) + "px";
            //弹出窗top位置计算
            if(this.$parent.fctype != "fvGroupObj"){
                this.domStyle.top  = parseInt(((this.y)* (scaleObj.sy + scaleObj.zoom)) + scaleObj.oy)+this.$el.parentElement.offsetTop+1 + "px";
            }else{
                this.domStyle.top  = parseInt(((this.y)* (scaleObj.sy + scaleObj.zoom)) + scaleObj.oy) + "px";
            }
            this.domStyle.width = parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) + "px";
            this.domStyle.height = parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + "px";
            this.$refs.pie.style.width = this.domStyle.width;
            this.$refs.pie.style.height = this.domStyle.height;
            this.myChart.resize();
        },  
        /*  
            多语言title
        */
        setPieTitle() {
            var resText = this.fvSystemApi.getResource(this.title);
            if(this.option.title.text != resText){
                this.option.title.text = resText ? resText : this.title;
                this.myChart.setOption({
                    title : {
                        text : this.option.title.text
                    }
                });;
            }
        },
        /*
            参数：e 鼠标信息
                 domScale 窗口放大、缩小、偏移等信息
            作用：鼠标事件调用函数，无必要可不进行任何处理
        */
        doFixedEvent(){},
        /*
            参数：无
            作用：系统周期调用
        */
        onTimer(time,flag){
            if(this.isEnable) return;
            this.getData();
        },
        /*
            参数：isShow 显示隐藏
            作用：设置组件整体显隐
        */
        Show(isShow){
            this.isShow = isShow ? true:false;
        },
        /*
            参数：isEnable 是否可用
            作用：设置组件是否可用
        */
        Enable(isEnable){
            this.isEnable = isEnable ? false : true;
        },
        /*
            作用：刷新静态数据
            参数：无
        */
        drawPie(){
            this.myChart.setOption(this.option);
        },
        /*
            作用：设置饼图位置
            参数：无
        */
        getPieLocation(){
            switch(this.pieLocation)
                {
                case "up":
                    return ["50%","25%"]
                break;
                case "down":
                    return ["50%","75%"]
                break;
                case "left":
                    return ["25%","50%"]
                break;
                case "right":
                     return ["75%","50%"]
                break;
                case "leftUp":
                     return ["25%","25%"]
                break;
                case "rightUp":
                     return ["75%","25%"]
                break;
                case "leftDown":
                     return ["25%","75%"]
                break;
                case "rightDown":
                     return ["75%","75%"]
                break;
                default:
                    return["50%","50%"]
                }
        },
        /*
            作用：更新饼图data数据
            参数：无
        */
        updateData(){
            var legend = [];
            // 获取曲线option数据
            var option = this.myChart.getOption();
            // 获取图例数据
            this.realData.forEach((el) =>{
                legend.push(el.name);
            })
            // 改变option中对应的数据
            option.series[0].data = [];
            option.legend[0].data = [];
            option.series[0].data = [...this.realData];
            option.legend[0].data = [...legend];
            // 刷新曲线数据
            this.myChart.setOption(option);
        },
        /*
            作用：获取实时数据
            参数：无
        */
        async getData(){
            // 对undefined做出处理，因为数据库请求点数据均为为坏点，暂时将其改为随机值以便效果展示
            for(var i = 0; i<this.data.length; i++){
                var num = await this.fvSystemApi.getReal(this.data[i].tagName);
                this.data[i]["value"] = num == undefined ? -9999 : num.PV;
                // this.$set(this.data[i],"value",Math.random()*100+1);
            }
            for(var k in this.data){
                this.$set(this.virtualData,k,this.data[k]);
            }
            this.updateData();
        },
    }
}
</script>
<style>
   
</style>



// WEBPACK FOOTER //
// src/components/primitives/fvPie/fvPie.vue